/* ------------------------------------------------------------------
   Footer "live chat" -> opens the Shopify storefront chat widget.
   The online store chat app embed renders a <shopify-chat> element on
   every page; setting its `open` attribute opens the chat panel.
------------------------------------------------------------------ */
(function () {
  function openChat() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) { return false; }
    chat.setAttribute('open', '');
    return true;
  }

  function markItems() {
    var items = document.querySelectorAll('.info-content-wp .info-content-text');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.hasAttribute('data-live-chat-trigger')) { continue; }
      if (!/live\s*chat/i.test((el.textContent || '').trim())) { continue; }
      el.setAttribute('data-live-chat-trigger', 'true');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.style.cursor = 'pointer';
    }
  }

  function handleTrigger(event) {
    var target = event.target;
    if (!target || !target.closest) { return; }
    if (!target.closest('[data-live-chat-trigger]')) { return; }
    event.preventDefault();
    openChat();
  }

  document.addEventListener('click', handleTrigger);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') { return; }
    handleTrigger(event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markItems);
  } else {
    markItems();
  }

  document.addEventListener('shopify:section:load', markItems);
})();
